export default "__VITE_PUBLIC_ASSET__f741b6d3__"